import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getEquipmentPhotos(companyId, equipmentId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		dtConfig[ModulesMap.EQUIPMENT_PHOTOS].getEquipmentPhotos,
		{
			urlParams: {
				companyId,
				equipmentId,
			},
		},
		cashedPayload
	)
}
function getEquipmentPhoto(companyId, equipmentId, photoId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		dtConfig[ModulesMap.EQUIPMENT_PHOTOS].getEquipmentPhoto,
		{
			urlParams: {
				companyId,
				equipmentId,
				photoId,
			},
		},
	)
}

function createEquipmentPhoto(companyId, equipmentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		dtConfig[ModulesMap.EQUIPMENT_PHOTOS].createEquipmentPhoto,
		{
			urlParams: {
				companyId,
				equipmentId,
			},
			...data,
		},
	)
}
function putEquipmentPhoto(companyId, equipmentId, photoId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		dtConfig[ModulesMap.EQUIPMENT_PHOTOS].putEquipmentPhoto,
		{
			urlParams: {
				companyId,
				equipmentId,
				photoId,
			},
			...data,
		},
	)
}
function patchEquipmentPhoto(companyId, equipmentId, photoId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		dtConfig[ModulesMap.EQUIPMENT_PHOTOS].patchEquipmentPhoto,
		{
			urlParams: {
				companyId,
				equipmentId,
				photoId,
			},
			...data,
		},
	)
}
function deleteEquipmentPhoto(companyId, equipmentId, photoId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_PHOTOS,
		dtConfig[ModulesMap.EQUIPMENT_PHOTOS].deleteEquipmentPhoto,
		{
			urlParams: {
				companyId,
				equipmentId,
				photoId,
			},
		},
	)
}
export default {
	getEquipmentPhotos,
	getEquipmentPhoto,
	createEquipmentPhoto,
	putEquipmentPhoto,
	patchEquipmentPhoto,
	deleteEquipmentPhoto,
}
